import o from "./_isStrictComparable.js";
import l from "./keys.js";
var m = o, s = l;
function h(a) {
  for (var t = s(a), r = t.length; r--; ) {
    var e = t[r], i = a[e];
    t[r] = [e, i, m(i)];
  }
  return t;
}
var c = h;
export {
  c as default
};
//# sourceMappingURL=_getMatchData.js.map
